import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=7c7c96d4&scoped=true"
import script from "./AdminEdit.vue?vue&type=script&lang=js"
export * from "./AdminEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminEdit.vue?vue&type=style&index=0&id=7c7c96d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7c96d4",
  null
  
)

export default component.exports